// extracted by mini-css-extract-plugin
export var fullWidthButton = "_105-0";
export var tagInputDisabled = "_105-1";